<template>
    <div class="wrapper">
      <div class="content-container">
        <div class="stingy-card">
          <!-- Introduction Section -->
          <div v-if="showIntroduction" class="introduction-section">
            <img :src="require('@/assets/loanofficercat.png')" alt="Loan Officer Cat" width="200" height="200">
            <h2>Welcome {{ userName }} to the Foundational Investing in Canada Quiz!</h2>
            <p>Before you proceed to your role as a bank fraud officer, it's important to understand the basics of investing in Canada. This will help you in identifying potential fraud related to investment accounts.</p>
            <button class="option-button" @click="startGame">Start Game</button>
          </div>
  
          <!-- Quiz Section -->
          <div v-else class="quiz-container">
            <h2 class="quiz-title">{{ quizTitle }}</h2>
            <div v-if="currentQuestionIndex < questions.length" class="question-container">
              <p class="question">{{ questions[currentQuestionIndex].description }}</p>
              <div class="options-container">
                <button class="option-button" @click="submitAnswer(true)">Yes</button>
                <button class="option-button" @click="submitAnswer(false)">No</button>
              </div>
            </div>
  
            <!-- Summary Section -->
            <div v-else class="summary-container">
              <h3>Quiz Summary</h3>
              <p>Your score: {{ score }}%</p>
              <p v-if="score >= 70">Congratulations! You've passed and are ready to proceed.</p>
              <p v-else>Unfortunately, you did not pass. Investing knowledge is crucial for fraud prevention. Try again!</p>
              <button @click="restartQuiz" class="restart-quiz-button">Restart Quiz</button>
              <!-- Adding navigation to the next component if passed -->
              <router-link v-if="score >= 70" to="/games/bankteller1" class="next-quiz-button">Proceed to Bank Teller Simulation</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
 <br><br><br><br><br><br><br>
  </template>
  
  <script>
  import { ref, computed, onMounted } from 'vue';
  import { Auth } from 'aws-amplify';
  
  export default {
    setup() {
      const showIntroduction = ref(true);
      const userName = ref(''); // Initial empty string for user's name
      const quizTitle = ref("Foundational Investing in Canada");
      const questions = ref([
        {
          description: "Is investing in a Tax-Free Savings Account (TFSA) subject to capital gains tax in Canada?",
          correctAnswer: false,
        },
        {
          description: "Can you hold both Canadian and foreign stocks in a Registered Retirement Savings Plan (RRSP)?",
          correctAnswer: true,
        },
        {
          description: "Is it required by Canadian law for mutual funds to disclose their Management Expense Ratio (MER) to investors?",
          correctAnswer: true,
        },
        {
          description: "Does investing in Exchange-Traded Funds (ETFs) offer more diversification than individual stocks?",
          correctAnswer: true,
        },
        {
          description: "Is it legal in Canada to participate in insider trading based on confidential information for personal gain?",
          correctAnswer: false,
        },
        {
          description: "Can the Canada Deposit Insurance Corporation (CDIC) insure investments in stocks and bonds?",
          correctAnswer: false,
        },
        {
          description: "Is it possible to lose the principal amount in a Guaranteed Investment Certificate (GIC) in Canada?",
          correctAnswer: false,
        },
        {
          description: "Do Canadian investors have protection up to $1 million if their brokerage firm goes bankrupt?",
          correctAnswer: true, // 
        },
        {
          description: "Are dividend payments from Canadian corporations eligible for a tax credit in Canada?",
          correctAnswer: true,
        },
        {
          description: "Is it mandatory for all investment advisors in Canada to be registered with a provincial securities regulator?",
          correctAnswer: true,
        },
        {
  description: "Is mortgage interest generally tax-deductible for a primary residence in Canada?",
  correctAnswer: false, // In Canada, mortgage interest on your primary residence is not tax-deductible, unlike in some other countries.
},
{
  description: "Can first-time home buyers in Canada withdraw from their RRSPs to contribute towards their home purchase without immediate tax penalties?",
  correctAnswer: true, // Through the Home Buyers' Plan, first-time home buyers can withdraw amounts from their RRSPs to purchase or build a home without immediate tax penalties.
},
{
  description: "Is a higher credit score a potential factor for receiving a lower interest rate on a mortgage in Canada?",
  correctAnswer: true,
},
{
  description: "In Canada, can landlords increase rent at any time and by any amount?",
  correctAnswer: false, // Landlords are subject to provincial regulations, which often include restrictions on the timing and percentage of rent increases.
},
{
  description: "Are fixed-rate mortgage payments constant throughout the term in Canada?",
  correctAnswer: true,
},
{
  description: "Is it mandatory in Canada to have home insurance when owning a home?",
  correctAnswer: false, // While not legally mandatory, most mortgage lenders require home insurance.
},
{
  description: "Can tenants in Canada sublet their rental property without the landlord's consent?",
  correctAnswer: false, // The ability to sublet depends on the lease agreement and provincial laws, but generally, landlord consent is required.
},
{
  description: "Is the interest on investment loans tax-deductible in Canada?",
  correctAnswer: true, // Interest on loans taken out to earn investment income is generally tax-deductible in Canada.
},
{
  description: "Do REITs (Real Estate Investment Trusts) in Canada typically offer dividends that are tax-advantaged compared to regular corporate dividends?",
  correctAnswer: false, // REIT dividends are often taxed as income, not eligible for the dividend tax credit.
},
{
  description: "Is it possible for non-residents to purchase property in Canada?",
  correctAnswer: true,
},
{
  description: "Must a Canadian investor always use a broker to purchase stocks?",
  correctAnswer: false, // While using a broker is common, investors can also buy stocks through direct purchase plans, online trading platforms, etc.
},
{
  description: "Are there any circumstances under which a security deposit can be legally kept by the landlord in Canada?",
  correctAnswer: true, // Landlords can keep part or all of the deposit for unpaid rent, damage beyond normal wear and tear, and other breaches of the lease terms.
},
{
  description: "Is it required to have a down payment of at least 20% when purchasing a home in Canada?",
  correctAnswer: false, // The minimum down payment varies, but it can be as low as 5% for insured mortgages.
},
{
  description: "Can investing in commodities like gold and silver be done through a TFSA in Canada?",
  correctAnswer: true, // Commodities can be invested in indirectly through ETFs or mining company stocks within a TFSA.
},
{
  description: "Do all provinces in Canada require a rental agreement to be in writing?",
  correctAnswer: false, // While written agreements are strongly recommended and required in some provinces, not all provinces mandate them.
}
      ]);
  
      const fetchUserName = async () => {
        try {
          const user = await Auth.currentAuthenticatedUser();
          userName.value = user.attributes.name; // Or user.attributes.name if using custom attributes
        } catch (error) {
          console.error('Error fetching user information:', error);
        }
      };
  
      const currentQuestionIndex = ref(0);
      const correctAnswers = ref(0);
  
      const startGame = () => {
        showIntroduction.value = false;
      };
  
      const submitAnswer = (answer) => {
        if (answer === questions.value[currentQuestionIndex.value].correctAnswer) {
          correctAnswers.value++;
        }
        currentQuestionIndex.value++;
      };
  
      const restartQuiz = () => {
        currentQuestionIndex.value = 0;
        correctAnswers.value = 0;
      };
  
      const score = computed(() => Math.round((correctAnswers.value / questions.value.length) * 100));
  
      onMounted(() => {
        fetchUserName();
      });
  
      return {
        showIntroduction,
        quizTitle,
        currentQuestionIndex,
        questions,
        score,
        startGame,
        submitAnswer,
        restartQuiz,
        userName,
      };
    },
  };
  </script>
  
  <style scoped>
  .quiz-container {
    background-color: #fff; 
    color: #36454f; /* Dark font color for contrast */
    padding: 20px;
    border-radius: 10px;
    max-width: 600px;
    margin: 20px auto; /* Center container and give some space around */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Soft shadow for depth */
    text-align: center;
  }
  
  .question-container, .summary-container {
    text-align: center;
  }
  
  .question {
    font-size: 1.25rem; /* Larger font size for readability */
    color: #36454f ;
    margin: 20px 0; /* Space around the question */
    text-align: center;
  }
  
  .options-container {
    display: flex;
    justify-content: center;
    gap: 10px; /* Space between options */
  }
  
  .option-button {
    cursor: pointer;
    background-color: #333;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    transition: background-color 0.3s;
  }
  
  .option-button:hover {
    background-color: #d0ccd3; /* Darker shade on hover */
    transform: translateY(-2px); /* Slight lift effect */
  }
  
  .restart-quiz-button {
    background-color: #36454f; /* Dark background for contrast */
    color: white; /* White text for readability */
    border: none; /* No border for a modern look */
    padding: 10px 20px; /* Padding for size */
    cursor: pointer; /* Cursor to pointer to indicate it's clickable */
    border-radius: 25px; /* Rounded corners for a softer look */
    font-weight: bold; /* Bold text for emphasis */
    transition: background-color 0.3s; /* Smooth transition for hover effects */
    margin-top: 20px; /* Space from the content above */
  }
  
  .restart-quiz-button:hover {
    background-color: #4A148C; /* Lighter purple on hover for visual feedback */
  }

 .next-quiz-button {
  /* Style similar to the restart-quiz-button for consistency */
  background-color: #4A148C; /* Example color */
  color: white;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 25px;
  font-weight: bold;
  margin-top: 10px;
}

.next-quiz-button:hover {
  background-color: #362f78; /* Darker on hover */
}

.wrapper {
    display: flex;
  justify-content: center;
  align-items: center;
}
.intro-image {
  margin-bottom: 20px;
}
.content-container {
background-color: #4A148C ;  /* Light orange color */
text-align: center;
  max-width: 600px;
  width: 100%;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}
.stingy-card {
flex: 1;  /* Take up equal width as the iframe */
padding: 20px;
border-radius: 8px;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
background-color: white;
color: black;
}
  </style>